import React from "react";
import PropTypes from "prop-types";
import ProgressIndicator from "components/ProgressIndicator";
import { styled } from "@mui/material/styles";

export default function ProgressIndicatorOverlay({ loading, error }) {
  if (loading) {
    return (
      <Overlay>
        <ProgressIndicator loading={loading} error={error} />
      </Overlay>
    );
  }

  return null;
}

const Overlay = styled("div")`
  background-color: rgba(0, 0, 0, 0.5);
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 100;
`;

ProgressIndicatorOverlay.propTypes = {
  loading: PropTypes.bool.isRequired,
  error: PropTypes.oneOfType([PropTypes.object, PropTypes.bool])
};
